import React from 'react';
import { withRouter } from "react-router-dom";
import DigitalSignature from './DigitalSignatureComponent';

const DigitalSignatureLanding = (props) => {
    return <DigitalSignature/>
}
export default withRouter(DigitalSignatureLanding);